import React from "react";
import { cn } from "@/lib/utils";

/**
 * Subtle dot / grid SVG background pattern.
 * Absolutely positioned by default so it sits behind content.
 *
 * Props:
 *   variant: "dots" | "grid" (default "dots")
 *   size: px cell size (default 32)
 *   opacity: 0..1 (default 0.5)
 *   fade: boolean (radial mask so edges fade out) — default true
 */
export const GridPattern = ({
  variant = "dots",
  size = 32,
  opacity = 0.5,
  fade = true,
  className,
  ...props
}) => {
  const id = React.useId();

  return (
    <svg
      aria-hidden="true"
      className={cn(
        "pointer-events-none absolute inset-0 h-full w-full",
        fade && "mask-radial-fade",
        className,
      )}
      style={{ opacity }}
      {...props}
    >
      <defs>
        {variant === "dots" ? (
          <pattern
            id={id}
            x="0"
            y="0"
            width={size}
            height={size}
            patternUnits="userSpaceOnUse"
          >
            <circle cx="1" cy="1" r="1" fill="rgba(255,255,255,0.12)" />
          </pattern>
        ) : (
          <pattern
            id={id}
            x="0"
            y="0"
            width={size}
            height={size}
            patternUnits="userSpaceOnUse"
          >
            <path
              d={`M ${size} 0 L 0 0 0 ${size}`}
              fill="none"
              stroke="rgba(255,255,255,0.06)"
              strokeWidth="1"
            />
          </pattern>
        )}
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id})`} />
    </svg>
  );
};

export default GridPattern;
